import { FormHelperText } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export function userInputErrorComponent(message: string) {
  return (
    <FormHelperText
      sx={{
        display: "flex",
        alignItems: "center",
        color: "red",
        fontSize: "10px",
        margin: 0,
      }}
    >
      <ErrorOutlineIcon
        sx={{
          fontSize: "16px",
          marginRight: "4px",
        }}
      />
      {message}
    </FormHelperText>
  );
}
export default userInputErrorComponent;
